<div class="container-fluid p-0" style="overflow: hidden;">
  <!-- <div class="main-content"> -->
  <!-- Top navbar -->
  <app-navbar-public></app-navbar-public>
  <!-- Pages -->
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
